module.exports = __webpack_public_path__ + "img/DX-255.2880d31a.jpg";